export const commissionConstants = {
    GET_COMMISSION_SUCCESS:  'GET_COMMISSION_SUCCESS',

    SHOW_COMMISSION_SUCCESS: 'SHOW_COMMISSION_SUCCESS',

    UPDATE_COMMISSION_SUCCESS: 'UPDATE_COMMISSION_SUCCESS',
    
};